import { PrismicDocument } from '@prismicio/client';

export class Channel {
  /** Prismic id  */
  public readonly id: PrismicDocument['id'];
  /** Two letter short code */
  public readonly code: PrismicDocument['data']['channel_code'];
  public readonly name: PrismicDocument['data']['channel_name'];

  constructor(prismicData: PrismicDocument) {
    this.id = prismicData.id;
    this.code = prismicData.data['channel_code'];
    this.name = prismicData.data['channel_name'];
  }
}
